import { post } from '../request';

// 用户相关接口
export const userApi = {
  // 用户登录
  login: (data: any) => post<any>('/pc/user/login', data)
};
